export default {
  computed: {
    oephMixin_loadingError() {
      return this.$store.getters.getApiHttpStatus('object') !== 200;
    },
    oephMixin_errorComponent() {
      if (this.$store.getters.getApiHttpStatus('object') === 404) return 'error404';
      if (this.$store.getters.getApiHttpStatus('object') === 410) return 'error410';
      return 'error500';
    },
  },
  methods: {
    oephMixin_apiErrorHandler(e) {
      const { status = 500 } = e;
      if (e.errorLength === 1) {
        const [objectError] = e.errors;
        if (objectError.appInform) {
          const { isKey, text, header = '' } = objectError;
          if (text) {
            if (isKey) {
              const errorHead = this.$t(`errors:object.${text}.header`);
              let errorBody = this.$t(`errors:object.${text}.body`);
              if (errorBody.includes(`errors:object.${text}.body`)) { // no body defined for this error message
                errorBody = '';
              }
              this.$store.commit('SET_API_ERROR_TEXT', { header: errorHead, body: errorBody });
            } else {
              this.$store.commit('SET_API_ERROR_TEXT', { header, body: text });
            }
          }
        }
      }
      this.$store.commit('SET_APP_APIHTTPSTATUS', { type: 'object', status });
    }
  }
};
